import { stripMarkdown } from 'lib/string/stripMarkdown'

export default function getPlainSummaryDescription(description: string): string {
  return stripMarkdown(description.replace(/!\[[^\]]*\]\([^)]*\)/g, ''))
    .replace(/https?:\/\/\S+/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}
